/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { Button, Avatar, useBreakpoint } from 'sarsaparilla';

import { useGetAvatarUrl, useUserName } from './Navbar.utils';

interface AvatarTriggerButtonProps {
    onClick: () => void;
}

export function AvatarTriggerButton({ onClick }: AvatarTriggerButtonProps) {
    const avatarUrl = useGetAvatarUrl();
    const userName = useUserName();
    const { isMdAndDown } = useBreakpoint();

    if (isMdAndDown) {
        return null;
    }

    return (
        <Button
            appearance="link"
            className="px-1"
            aria-label={`User: ${userName}`}
            onClick={onClick}
        >
            <Avatar
                src={avatarUrl}
                alt={userName}
                size="sm"
                className="data-hj-suppress mr-1"
            />
            <span className="data-hj-suppress">{userName}</span>
        </Button>
    );
}

// cSpell:ignore recaccount
